export const POLISHING_HISTORY_REQUEST = "POLISHING_HISTORY_REQUEST";
export const POLISHING_HISTORY_SUCCESS = "POLISHING_HISTORY_SUCCESS";
export const POLISHING_HISTORY_FAILED = "POLISHING_HISTORY_FAILED";